/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener("theme:product:add", function (event) {
    console.log("product added");
    updateCheckoutButton();
    setTimeout(() => {
      const cartItemRemove = document.querySelectorAll(".cart__item__remove");
      cartItemRemove.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          console.log("Cart item removed");
          setTimeout(() => {
            updateCheckoutButton();
          }, 1000);
        });
      });
    }, 2000);
  });

  document.addEventListener("theme:cart:update", function (event) {
    console.log("cart updated");
    updateCheckoutButton();
  });

  const cartItemRemove = document.querySelectorAll(".cart__item__remove");
  cartItemRemove.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      console.log("Cart item removed");
      setTimeout(() => {
        updateCheckoutButton();
      }, 1000);
    });
  });
  function remove() {
    console.log("product removed");
    updateCheckoutButton();
  }
  function updateCheckoutButton() {
    const alltags = [];
    console.log("running");
    let hasChain = false;
    let hasOnlyNecklace = false;
    let counter  = 0;
    let tags = [];
    let checkoutBtn = document.querySelector("[name='checkout']");
    let warningMsg = document.getElementById("checkout-warning");
    
    fetch("/cart.js") // Fetch updated cart
      .then((response) => response.json())
      .then((cart) => {
        let totalItems = cart.items.length;
        for (let item of cart.items) {
          
          if (item.product_type.includes("Choker") || item.product_type.includes("Candle") || item.product_type.includes("Chain")) {
            console.log("chain or candle found");
            hasChain = true;
            counter++;
          }
        }
        hasOnlyNecklace = (counter === totalItems);
        if (hasOnlyNecklace) {
          console.log("in");
          checkoutBtn.disabled = true;
          checkoutBtn.style.opacity = "0.5";
          checkoutBtn.style.cursor = "not-allowed";
          if (!warningMsg) {
            let msg = document.createElement("p");
            msg.id = "checkout-warning";
            msg.className = "text-warning";
            msg.innerText =
              "These products are not sold separately and are only available for purchase when ordering any of our larimar or amber jewelry.";
            checkoutBtn.parentNode.insertBefore(msg, checkoutBtn);
          }
        } else {
          checkoutBtn.disabled = false;
          checkoutBtn.style.opacity = "1";
          checkoutBtn.style.cursor = "pointer";
          if (warningMsg) {
            warningMsg.remove();
          }
        }
      });
  }

  updateCheckoutButton();
setTimeout(() => {
  var badge = document.querySelector(".product__price__wrap"); 
  var sale = document.querySelector(".product__sale");
    var size = document.querySelector(".radio__fieldset.radio__fieldset--single");
  
        if (badge) {
        var price = document.querySelector(".product__block.product__head");
          price.append(badge);
        }
  if(sale) {
    var badgecontainer = document.querySelector(".product__badges");
      badgecontainer.append(sale);
    
  }
  if(size) {
    var badgecontainer = document.querySelector(".radio__legend__label.radio__legend__label--text");
      badgecontainer.append(size);
    
  }
 
      }, 200);
  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
